import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Text.module.scss'

type Size = 'sm' | 'base' | 'lg'
type Tone = 'default' | 'secondary' | 'muted' | 'inherit'

interface TextProps {
  children: React.ReactNode
  size?: Size
  tone?: Tone
}

const sizeMap: Record<Size, string> = {
  sm: styles.sizeSm, base: styles.sizeBase, lg: styles.sizeLg,
}

const toneMap: Record<Tone, string> = {
  default: styles.toneDefault,
  secondary: styles.toneSecondary,
  muted: styles.toneMuted,
  inherit: styles.toneInherit,
}

export const Text: React.FC<TextProps> = ({ children, size = 'base', tone = 'default' }) => (
  <p className={cx(styles.text, sizeMap[size], toneMap[tone])}>{children}</p>
)
